function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import { formatDate } from 'helpers/datetime';
import { IMB_STATUS_DISPLAY_MAP } from 'modules/MobileReports/types';
import { imbPatterns as imbPatternsSelector } from 'modules/PatientResults/selectors';
import messages from '../../../messages';
import styles from './Footer.pcss';
const DetectedAndStatus = (props)=>{
    const { patternBGStartDate, patternStatusCode, patternBGEndDate, patternCategoriesCode } = props;
    const detected = /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.detected));
    const displayStatus = IMB_STATUS_DISPLAY_MAP[patternStatusCode];
    const statusMessage = displayStatus ? /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.IMBPatterns.statuses[displayStatus])) : patternStatusCode;
    const startDate = formatDate(patternBGStartDate);
    const endDate = formatDate(patternBGEndDate);
    if (patternCategoriesCode === 'ARCHIVE') {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                ": ",
                detected,
                " ",
                startDate,
                ", ",
                statusMessage,
                " ",
                endDate,
                "."
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            ": ",
            detected,
            " ",
            startDate,
            "."
        ]
    });
};
const getDescriptionVariant = (status, category)=>{
    if (category === 'NEW' || category === 'ACTIVE' || category === 'ADDITIONAL') return 'normal';
    const displayStatus = IMB_STATUS_DISPLAY_MAP[status];
    if (displayStatus === 'IMPROVED' || displayStatus === 'OVERCORRECTED') return 'positive';
    if (displayStatus === 'NEEDS_IMPROVEMENT' || displayStatus === 'NOT_IMPROVED') return 'negative';
    return 'normal';
};
const Description = (props)=>{
    const { patternDescription, patternStatusCode, patternCategoriesCode, patternTargetDate } = props;
    const variant = getDescriptionVariant(patternStatusCode, patternCategoriesCode);
    const message = messages.IMBPatterns.patternDescriptions[patternDescription][variant];
    if (patternDescription === 'DAY_OF_THE_WEEK_LOW' || patternDescription === 'DAY_OF_THE_WEEK_HIGH') {
        const dayOfWeek = formatDate(patternTargetDate, 'dddd');
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, message), {
            values: {
                dayOfWeek
            }
        }));
    }
    return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, message));
};
const IMBPattern = (props)=>{
    const { patternDescription, patternBGStartDate, patternStatusCode, patternBGEndDate, patternTargetDate } = props;
    const nameValues = patternDescription === 'DAY_OF_THE_WEEK_LOW' || patternDescription === 'DAY_OF_THE_WEEK_HIGH' ? {
        dayOfWeek: formatDate(patternTargetDate, 'dddd')
    } : undefined;
    return /*#__PURE__*/ _jsxs("li", {
        children: [
            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.IMBPatterns.patternNames[patternDescription]), {
                values: nameValues
            })),
            /*#__PURE__*/ _jsx(DetectedAndStatus, _object_spread({}, props)),
            ' ',
            /*#__PURE__*/ _jsx(Description, _object_spread({}, props))
        ]
    }, `IMBPattern-${patternBGStartDate}-${patternStatusCode}-${patternBGEndDate}`);
};
const Content = ()=>{
    const imbPatterns = useSelector(imbPatternsSelector);
    if (!imbPatterns || !imbPatterns.length) {
        return /*#__PURE__*/ _jsx("ul", {
            children: /*#__PURE__*/ _jsx("li", {
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.noimbPatterns))
            })
        });
    }
    return /*#__PURE__*/ _jsx("ul", {
        children: imbPatterns.map((value)=>/*#__PURE__*/ _jsx(IMBPattern, _object_spread({}, value)))
    });
};
export const IMBPatterns = ()=>{
    useStyles(styles);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.footer__patterns,
        children: [
            /*#__PURE__*/ _jsx("h3", {
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.imbPatterns))
            }),
            /*#__PURE__*/ _jsx(Content, {})
        ]
    });
};
